module.exports = __webpack_public_path__ + "static/mysql-98539cdcb0d5dd38c87ec53b084706d6.svg";